import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Location, NavLink, Outlet, useLocation } from "react-router-dom";
import BackButton from "../../components/templates/components/backButton";
import { EvmcType } from "../../models/EvmcSelections";

const EvmcPage: FC = () => {

  const location = useLocation();
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState(getTypeFromURL(location));

  useEffect(() => {
    changeType(getTypeFromURL(location));
  }, [location]);

  const changeType = (newType?: EvmcType): void => {
    setCurrentType(newType);
  };

  function getTypeFromURL(location: Location) {
    return location.pathname.endsWith("CATEGORY")
      ? EvmcType.CATEGORY
      : location.pathname.endsWith("EDUCATION")
      ? EvmcType.EDUCATION
      : location.pathname.endsWith("LIVING")
      ? EvmcType.LIVING
      : undefined;
  }

  const TopButton: FC<{ 
    type: EvmcType; 
    selected: boolean;
    to: string; 
  }> = ({
    type,
    selected,
    to,
  }) => (
    <Button
      className="nav-link"
      component={NavLink}
      variant={selected ? "contained" : "outlined"}
      to={to}
      size="small"
      onClick={() => changeType(type)}
    >
      {t(`evmc-${type}`)}
    </Button>
  );

  return (
    <>
      <div className="back-container">
        <BackButton></BackButton>
      </div>
      <nav
        role="navigation"
        aria-label={ t("aria-label--evmc-menu") || undefined }
      >
        <div role="tablist" className="switcher-container">
          <ul>
            <li role="tab">
              <TopButton
                to="LIVING"
                type={EvmcType.LIVING}
                selected={currentType === EvmcType.LIVING}
              />
            </li>
            <li role="tab">
              <TopButton
                to="EDUCATION"
                type={EvmcType.EDUCATION}
                selected={currentType === EvmcType.EDUCATION}
              />
            </li>
            <li role="tab">
              <TopButton
                to="CATEGORY"
                type={EvmcType.CATEGORY}
                selected={currentType === EvmcType.CATEGORY}
              />
            </li>
          </ul>
        </div>
      </nav>
      <Outlet />
    </>
  );
};

export default EvmcPage;
